module.exports = __webpack_public_path__ + "static/media/box-add-icon.eea66c06.svg";